import * as d3 from 'd3-selection'
import Rotator from './rotator'
import Lasso from './lasso'

class Draggable {

  constructor (config, ee, svg, map) {
    // These are called by event emitters, make sure they are always
    // properly bound to `this`
    this.start = this.start.bind(this)
    this.drag = this.drag.bind(this)
    this.end = this.end.bind(this)

    if (config.globe) {
      this._draggable = new Rotator(ee, svg, map)
    } else {
      this._draggable = new Lasso(ee, svg, map)
    }
  }

  start () {
    this._draggable.start.apply(this, arguments)
  }

  drag () {
    this._draggable.drag.apply(this, arguments)
  }

  end () {
    this._draggable.end.apply(this, arguments)
  }
}

export default Draggable
